import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginTop: "10px",
      textAlign: "left",
      [theme.breakpoints.up("mobile")]: {
        justifyContent: "space-between",
      },
      "& button": {
        minWidth: "auto",
      },
    },
    placeholder: {
      width: "120px",
      [theme.breakpoints.up("mobile")]: {
        display: "inline-block",
      },
    },
    service: {
      textTransform: "none",
      fontWeight: "normal",
      paddingLeft: 0,
      "& p": {
        verticalAlign: "middle",
        cursor: "pointer",
        [theme.breakpoints.up("mobile")]: {
          display: "inline",
        },
      },
      "& img": {
        width: "60px",
        height: "60px",
        marginRight: "10px",
        verticalAlign: "middle",
        cursor: "pointer",
      },
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  }),
  { name: "Identity" },
);
